@if (loading()) {
  <app-cab-loading height="250px" />
} @else {
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="modal-body">
      <app-cab-input
        [controlName]="form.get('soato')"
        label="GEOGRAPHY.MODAL_BUTTON.SOATO"
      />
      <app-cab-input
        [controlName]="form.get('cadastralCode')"
        label="GEOGRAPHY.REGIONS.TABLE_HEADERS.CADASTRAL_CODE"
      />
      <app-cab-tab class="mt-3">
        <div id="first">
          <app-cab-input
            [controlName]="form.get('name_uz')"
            type="text"
            label="GEOGRAPHY.REGIONS.MODAL.NAME_UZ"
          />
        </div>
        <div id="second">
          <app-cab-input
            [controlName]="form.get('name_crl')"
            type="text"
            label="GEOGRAPHY.REGIONS.MODAL.NAME_CRL"
          />
        </div>
        <div id="third">
          <app-cab-input
            [controlName]="form.get('name_ru')"
            type="text"
            label="GEOGRAPHY.REGIONS.MODAL.NAME_RU"
          />
        </div>
      </app-cab-tab>
    </div>

    <div class="d-flex justify-content-end gap-3 modal-footer">
      <app-cab-button
        [disabled]="form.invalid"
        [isPending]="isPending()"
        label="GEOGRAPHY.MODAL_BUTTON.ADD_BUTTON"
        styleType="success"
        type="submit"
      />
      <app-cab-button
        (btnClick)="onCancel()"
        label="GEOGRAPHY.MODAL_BUTTON.CANCEL"
        styleType="light"
      />
    </div>
  </form>
}
